export default __webpack_public_path__ + "4d3eb55bf2ce5d09adfac5e52e9ad68a.svg";